// extracted by mini-css-extract-plugin
export default {"root":"cell-content-array_root__hWvJL","link":"cell-content-array_link__Zzuyg","placeHolderShimmer":"cell-content-array_placeHolderShimmer__tJ2wz"};